<template>
	<inertia-head title="TRC AI Circle Latest Updates" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">TRC AI Circle Latest Updates</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">TRC AI Circle Latest Updates Management</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded">
			<div class="block-header">
				<h3 class="block-title">TRC AI Circle Links</h3>
			</div>
			<div class="block-content block-content-full">
				<form @submit.prevent="saveSettings">
					<div class="row">
						<div class="col-lg-6 mb-3">
							<label class="form-label" for="trc_ai_circle_whatsapp_group_url">Exclusive WhatsApp Group Link</label>
							<input
								v-model="formSettings.trc_ai_circle_whatsapp_group_url"
								type="url"
								id="trc_ai_circle_whatsapp_group_url"
								name="trc_ai_circle_whatsapp_group_url"
								class="form-control"
								placeholder="https://chat.whatsapp.com/..."
							/>
						</div>
						<div class="col-lg-6 mb-3">
							<label class="form-label" for="trc_ai_circle_weekly_zoom_url">Weekly Zoom Link</label>
							<input
								v-model="formSettings.trc_ai_circle_weekly_zoom_url"
								type="url"
								id="trc_ai_circle_weekly_zoom_url"
								name="trc_ai_circle_weekly_zoom_url"
								class="form-control"
								placeholder="https://..."
							/>
						</div>
						<div class="col-12 text-end">
							<button
								type="submit"
								class="btn btn-alt-primary"
								:disabled="!formSettings.isDirty || formSettings.processing"
							>
								<i class="fa fa-save me-1"></i>Save Links
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="mb-4">
			<form @submit.prevent="searchRecords">
				<div class="row">
					<div class="col-md-9 mb-4">
						<div class="input-group">
							<input v-model="form.search" type="text" id="search" name="search" class="form-control" placeholder="Search" />
							<span class="input-group-btn">
								<button
									type="submit"
									class="btn btn-secondary"
									:disabled="!form.isDirty || form.processing"
								>
									<i class="fa fa-search me-1"></i>Search
								</button>
							</span>
						</div>
					</div>
					<div class="col space-x-1 mb-4 text-end">
						<button type="button" @click="viewTRCAiCircleBlogModal(0,'add')" class="btn btn-alt-primary">
							<i class="fa fa-plus me-1"></i>
							Add Latest Update
						</button>
					</div>
				</div>
			</form>
		</div>
		
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<!-- <div class="input-group">
						<div class="input-group-prepend"><span class="input-group-text">Category</span></div>
						<select v-model="membership_level" class="form-select">
							<option value="ALL">ALL</option>
							<option value="SILVER">SILVER</option>
							<option value="GOLD">GOLD</option>
							<option value="DIAMOND">DIAMOND</option>
							<option value="PLATINUM">PLATINUM</option>
						</select>
					</div> -->
				</div>
			</div>
			<div class="block-content block-content-full">
				<!-- Pagination -->
				<pagination v-if="trcAiCircleBlogs.data.length > 0" :collections="trcAiCircleBlogs"/>
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-hover table-vcenter">
						<thead>
							<tr>
								<th>TITLE</th>
								<th>MEDIA</th>
								<th>STATUS</th>
								<th nowrap="">DATE START</th>
								<th nowrap="">PUBLISHED DATE</th>
								<th>CREATED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(blog, a_index) in trcAiCircleBlogs.data"
								:key="blog.ai_circle_blog_uuid"
							>
								<td>{{blog.blog_title}}</td>
								<td>
									<img :src="blog.blog_image_url" style="width: 50%" />
									<div v-if="blog.vimeo_id" class="fs-xs text-muted mt-2">Vimeo: {{blog.vimeo_id}}</div>
								</td>
								<td>
									<span v-if="blog.is_active==0" class="text-danger">OFF</span>
									<span v-if="blog.is_active==1" class="text-success">ON</span>
								</td>
								<td>{{blog.date_start_format}}</td>
								<td>{{blog.date_published_format}}</td>
								<td>{{blog.created_at_format}}</td>
								<td class="text-end">
									<button @click="viewTRCAiCircleBlogModal(a_index,'update')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
									<button @click="confirmDelete(a_index)" type="button" class="btn btn-sm btn-alt-danger"><i class="fa fa-trash-alt"></i></button>
								</td>
							</tr>
							<tr v-if="trcAiCircleBlogs.data.length <= 0">
								<td colspan="7" class="mb-0 fw-semibold text-center p-5">NO TRC AI CIRCLE LATEST UPDATES FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="trcAiCircleBlogs.data.length > 0" :collections="trcAiCircleBlogs"/>
			</div>
		</div>
		<AddUpdateTRCAiCircleBlogModal ref="addUpdateTRCAiCircleBlogModal" />

		<modal ref="modalDelete" size="modal-lg">
			<template #title>DELETE CONFIRM</template>
			<template #body>
				<p>Are you sure, you want to delete this content?</p>
			</template>
			<template #footer>
				<button 
					@click="deleteTRCAiCircleBlog"
					type="submit"
					class="btn btn-alt-danger"
					:disabled="formDelete.processing"
				>
					<span v-if="!formDelete.processing"><i class="fa fa-check me-2"></i>Yes</span>
						<span v-else>
							<div class="spinner-border spinner-border-sm text-dark" role="status" >
								<span class="sr-only mr-1">Please wait...</span>
							</div>
							<span class="mx-2">Please wait...</span>
						</span>
				</button>
				<button
					@click="modalDelete.toggleModal"
					type="button"
					class="btn btn-alt-secondary"
					:disabled="formDelete.processing"
				>
					<i class="fa fa-times me-2"></i>NO
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import AuthLayout from '../../../Layouts/AuthLayout';
import AddUpdateTRCAiCircleBlogModal from '../../../Components/Admin/AddUpdateTRCAiCircleBlogModal';
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		search				: String,
		trcAiCircleBlogs	: Object,
		weekly_zoom_url 	: String,
		whatsapp_group_url 	: String,
		api_response 		: Object
	},
	components:{AddUpdateTRCAiCircleBlogModal},
	setup(props) {

		const action = ref('add');

		const toast = createToaster();

		const selectedTRCAiCircleBlog = reactive({});

		const form = useForm({
			search 	: props.search,
		});

		const formSettings = useForm({
			trc_ai_circle_whatsapp_group_url: props.whatsapp_group_url,
			trc_ai_circle_weekly_zoom_url: props.weekly_zoom_url,
		});

		const formDelete = useForm({
			ai_circle_blog_uuid 	: null,
			blog_image 		: null
		});

		const modalDelete 					= ref(null);
		const addUpdateTRCAiCircleBlogModal = ref(null);

		const searchRecords = () => {

			Inertia.get(route('admin.trc-ai-circle.latest-updates',{
					search 		: form.search
				})
			)
		}

		const saveSettings = () => {
			action.value = 'settings';

			formSettings.post(route('admin.trc-ai-circle.post.settings'), {
				preserveState: true,
				preserveScroll: true,
				only:['weekly_zoom_url','whatsapp_group_url','api_response'],
			})
		}

		const viewTRCAiCircleBlogModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedTRCAiCircleBlog.ai_circle_blog_uuid = props.trcAiCircleBlogs.data[_index].ai_circle_blog_uuid;
				selectedTRCAiCircleBlog.blog_title 			= props.trcAiCircleBlogs.data[_index].blog_title;
				selectedTRCAiCircleBlog.blog_tags 			= props.trcAiCircleBlogs.data[_index].blog_tags;
				selectedTRCAiCircleBlog.short_desc 			= props.trcAiCircleBlogs.data[_index].short_desc;
				selectedTRCAiCircleBlog.blog_desc 			= props.trcAiCircleBlogs.data[_index].blog_desc;
				selectedTRCAiCircleBlog.vimeo_id 			= props.trcAiCircleBlogs.data[_index].vimeo_id;
				selectedTRCAiCircleBlog.prev_blog_image 	= props.trcAiCircleBlogs.data[_index].prev_blog_image;
				selectedTRCAiCircleBlog.blog_image 			= props.trcAiCircleBlogs.data[_index].blog_image;
				selectedTRCAiCircleBlog.blog_image_url 		= props.trcAiCircleBlogs.data[_index].blog_image_url;
				selectedTRCAiCircleBlog.is_active 			= props.trcAiCircleBlogs.data[_index].is_active;
				selectedTRCAiCircleBlog.date_start 			= props.trcAiCircleBlogs.data[_index].date_start;
				selectedTRCAiCircleBlog.date_published 		= props.trcAiCircleBlogs.data[_index].date_published;
			}

			addUpdateTRCAiCircleBlogModal.value.setTrcAiCircleBlog(_action,selectedTRCAiCircleBlog);

			addUpdateTRCAiCircleBlogModal.value.toggleModal();

		}

		const confirmDelete = (_index)=>{
			formDelete.ai_circle_blog_uuid 		=  props.trcAiCircleBlogs.data[_index].ai_circle_blog_uuid;
			formDelete.blog_image 				=  props.trcAiCircleBlogs.data[_index].blog_image;
			modalDelete.value.toggleModal();
		}

		const deleteTRCAiCircleBlog = ()=>{
			action.value = 'delete';
			formDelete.delete('blogs/'+formDelete.ai_circle_blog_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['trcAiCircleBlogs,api_response'],
				onSuccess: () => {
					formDelete.reset();
					modalDelete.value.toggleModal();
				},
			})
		}

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : (action.value=='settings' ? 'updated' : 'updated'));

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "danger"});
				}
			}
		})

		return{
			toast,
			action,
			form,
			formSettings,
			formDelete,
			searchRecords,
			saveSettings,
			modalDelete,
			confirmDelete,
			deleteTRCAiCircleBlog,
			selectedTRCAiCircleBlog,
			viewTRCAiCircleBlogModal,
			addUpdateTRCAiCircleBlogModal
		}
	},
}
</script>
